<em-header></em-header>

<main class="main">
  <ng-content></ng-content>
</main>
